import React, { useRef, useState } from 'react'
import { Button, Dropdown, Form, InputGroup, Modal } from 'react-bootstrap'
import { CAMPAIGN_STATUS } from '..'
import Cookies from 'js-cookie'
import config from '../../../config'
import Swal from 'sweetalert2'
import { useDispatch } from 'react-redux'
import { getPublicUrl, getUploadImageUrl } from '../../../helpers/url'

const CreateCampaignModal = ({ show, selectedCampaign, handleCloseModal, onCreatedCampaign }) => {
  const [campaignData, setCampaignData] = useState({
    title: selectedCampaign?.title ?? '',
    description: selectedCampaign?.description ?? '',
    imageUrl: selectedCampaign?.imageUrl ?? '',
    buttonText: selectedCampaign?.redirectUrl?.name ?? '',
    buttonUrl: selectedCampaign?.redirectUrl?.url ?? '',
    status: CAMPAIGN_STATUS.ACTIVE,
  })
  const imageInputRef = useRef(null)
  const dispatch = useDispatch()

  const handleUpdateValue = (key, value) => {
    setCampaignData({ ...campaignData, [key]: value })
  }

  const handleUploadImage = async (event) => {
    const file = event.target.files[0]

    if (!file) {
      return setCampaignData({ ...campaignData, imageUrl: '' })
    }

    const img = new Image()
    img.src = URL.createObjectURL(file)
    img.onload = async () => {
      if (img.height <= 600 && img.width <= 1000) {
        try {
          dispatch({ type: 'loading_show' })

          const url = await getUploadImageUrl()
          const imageUrl = getPublicUrl(url)

          const response = await fetch(url, {
            method: 'PUT',
            body: file,
          })

          if (!response.ok) throw new Error('Error uploading image')

          return setCampaignData({ ...campaignData, imageUrl: imageUrl })
        } catch (error) {
          console.error(error)

          setCampaignData({ ...campaignData, imageUrl: '' })
          if (imageInputRef.current) {
            imageInputRef.current.value = null
          }

          Swal.fire({
            title: 'ไม่สามารถเพิ่มรูปภาพได้',
            html: 'กรุณาตรวจสอบขนาดไฟล์และ<br>นามสกุลไฟล์ที่รองรับ',
            icon: 'error',
          })
        } finally {
          dispatch({ type: 'loading_hide' })
        }
      } else {
        Swal.fire({
          title: 'เกิดข้อผิดพลาดในการอัพโหลดรูปภาพ',
          text: 'เนื่องจากรูปภาพมีขนาดเกิน 1000x600 ',
          icon: 'error',
        })
      }
    }
  }

  const handleCreateCampaign = async () => {
    if (!campaignData.imageUrl)
      return Swal.fire({
        title: 'กรุณาอัปโหลดรูปภาพ',
      })

    try {
      dispatch({ type: 'loading_show' })

      let response
      response = await fetch(
        `${config.apiAdminGateway}/api/v1/admin/notification/campaign${
          selectedCampaign?.id ? `/${selectedCampaign?.id}` : ''
        } `,
        {
          method: `${selectedCampaign?.id ? 'PUT' : 'POST'}`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${Cookies.get('accessToken')}`,
          },
          body: JSON.stringify({
            title: campaignData.title,
            description: campaignData.description,
            imageUrl: campaignData.imageUrl,
            status: campaignData.status,
            redirectUrl: {
              name: campaignData.buttonText,
              url: campaignData.buttonUrl,
            },
          }),
        },
      ).then((response) => response.json())

      if (response.status.code !== 0) {
        throw new Error('Error creating campaign')
      }

      Swal.fire({
        title: selectedCampaign?.id ? 'อัปเดตแคมเปญสำเร็จ' : 'สร้างแคมเปญสำเร็จ',
        icon: 'success',
      }).then(() => {
        onCreatedCampaign()
      })
    } catch (error) {
      console.error(error)
      Swal.fire({
        title: 'เกิดข้อผิดพลาด',
        text: 'ตรวจสอบข้อมูลและลองใหม่อีกครั้ง',
        icon: 'error',
      })
    } finally {
      dispatch({ type: 'loading_hide' })
    }
  }
  const validateUrl = (input) => {
    const pattern = /(^\w+[\w/]*)$/
    return input.match(pattern) || input === ''
  }
  return (
    <Modal show={show} onHide={handleCloseModal} size="lg">
      <Modal.Header>
        <Modal.Title>สร้างแคมเปญ</Modal.Title>
        <Button variant="" className="close" onClick={handleCloseModal}>
          <span>&times;</span>
        </Button>
      </Modal.Header>
      <Modal.Body>
        <Form className="">
          <Form.Row className="mb-2">
            <Form.Label>ชื่อ</Form.Label>
            <Form.Control
              type="text"
              value={campaignData.title}
              placeholder="กรอกชื่อแคมเปญ"
              onChange={(e) => handleUpdateValue('title', e.target.value)}
              maxLength={26}
            />
          </Form.Row>
          <Form.Row className="mb-2">
            <Form.Label>คำอธิบาย</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              value={campaignData.description}
              placeholder="กรอกคำอธิบายแคมเปญ"
              onChange={(e) => handleUpdateValue('description', e.target.value)}
              maxLength={64}
            />
          </Form.Row>
          <Form.Row className="mb-2">
            <Form.Label>ข้อความบนปุ่ม</Form.Label>
            <Form.Control
              value={campaignData.buttonText}
              maxLength={20}
              placeholder="กรอกข้อความบนปุ่ม"
              onChange={(e) => handleUpdateValue('buttonText', e.target.value)}
            />
          </Form.Row>
          <Form.Label>Link</Form.Label>
          <InputGroup>
            <InputGroup.Prepend>
              <InputGroup.Text id="basic-addon2">https://</InputGroup.Text>
            </InputGroup.Prepend>
            <Form.Control
              placeholder="กรอกลิ้งค์"
              value={campaignData.buttonUrl}
              onChange={(e) => {
                const text = e.target.value
                handleUpdateValue('buttonUrl', text)
              }}
            />
          </InputGroup>
          <Form.Label className="mb-3">
            <span style={{ color: 'rgb(225,0,0)', fontSize: '12px' }}>
              ตัวอย่าง ถ้าต้องการให้ไปหน้า คำสั่งซื้อ ให้พิมพ์ order ลงในช่องกรอกข้อมูล
            </span>
          </Form.Label>

          <Form.Row className="mb-2 flex-column">
            <Form.Label>สถานะ</Form.Label>
            <Dropdown>
              <Dropdown.Toggle className="primary light" id="dropdown-autoclose-outside">
                {campaignData.status}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {Object.values(CAMPAIGN_STATUS).map((status) => (
                  <Dropdown.Item onClick={() => handleUpdateValue('status', status)} key={status} value={status}>
                    {status}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </Form.Row>
          <Form.Row className="mb-2">
            <Form.Group>
              <Form.Label>
                รูปภาพ{' '}
                <span style={{ color: 'rgb(225,0,0)', fontSize: '12px' }}>
                  (เฉพาะไฟล์ .jpg หรือ .jpeg และขนาดต้องไม่เกิน 1000 X 600)
                </span>
              </Form.Label>
              <Form.Control
                type="file"
                ref={imageInputRef}
                onChange={handleUploadImage}
                accept="image/jpg,image/jpeg"
              />
            </Form.Group>
          </Form.Row>
          <Form.Row className="mb-2">
            {campaignData?.imageUrl && <img width="100%" alt="upload preview" src={campaignData?.imageUrl} />}
          </Form.Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger light" onClick={handleCloseModal}>
          ยกเลิก
        </Button>
        <Button variant="primary light" onClick={handleCreateCampaign}>
          ยืนยัน
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default CreateCampaignModal
